import { render } from "./holiday-header.vue?vue&type=template&id=9f56867c"
import script from "./holiday-header.vue?vue&type=script&lang=js"
export * from "./holiday-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__